import { registerApplication, start } from 'single-spa';
import { applications } from './applications';
import './single-spa-events/action-tabs';
import './single-spa-events/tenant-check';
import './release/variables';
import './style/index.css';
import './ember/load-css';

applications.forEach(registerApplication);

start({ urlRerouteOnly: true });
